import * as React from 'react'
import { Divider } from 'components/divider'
import { SingleAccordion } from 'components/single-accordion/single-accordion'
import { Link } from '@repo/web-ui/components/link'

interface LinkModuleProps {
  title?: string
  subtitle?: string
  sections: (LinkModuleSection | null)[]
  expanded?: boolean
}

export interface LinkModuleSection {
  title?: string
  links: LinkModuleLink[]
}

interface LinkModuleLink {
  label: string
  href: string
}

export function LinkModule(props: LinkModuleProps) {
  const { title, subtitle, sections, expanded = false } = props

  const hideModule =
    sections.find(section => section !== null && section.links.length > 0) === undefined

  if (hideModule) {
    return null
  }

  return (
    <div className="flex w-full flex-col gap-5">
      {title || subtitle ? (
        <div className="flex flex-col gap-[10px] text-center">
          {title ? (
            <h2 className="text-2xl font-bold md:text-[32px] md:leading-[42px]">{title}</h2>
          ) : null}
          {subtitle ? <p className="text-center text-sm">{subtitle}</p> : null}
        </div>
      ) : null}
      <div className="flex w-full flex-col gap-5">
        {sections.map((section, ind) => {
          if (!section) {
            return null
          }

          const sectionKey = `link_module_${section.title}_${ind}`

          return (
            <React.Fragment key={sectionKey}>
              <SingleAccordion
                header={section.title!}
                headerClasses="text-[20px] grow text-center"
                isInitialExpanded={expanded}
              >
                <div className="m-auto mt-5 grid grid-cols-[repeat(auto-fit,_minmax(200px,1fr))] justify-center gap-5">
                  {section.links.map((link, index) => (
                    <Link
                      key={`${sectionKey}_link_${index}`}
                      color="standard"
                      className="m-auto w-fit text-[14px] md:m-0 text-blue-500 no-underline hover:text-secondary-500"
                      href={link.href}
                    >
                      {link.label}
                    </Link>
                  ))}
                </div>
              </SingleAccordion>
              {ind < sections.length - 1 ? <Divider className="bg-[#dfdde5]" /> : null}
            </React.Fragment>
          )
        })}
      </div>
    </div>
  )
}
